import { createSelector, type Store } from "@reduxjs/toolkit";
import { useDispatch, useSelector, useStore } from "react-redux";
import { type RootState, type AppDispatch } from "./store";

// Typed hooks according to the docs:
// https://react-redux.js.org/using-react-redux/usage-with-typescript#define-typed-hooks
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<Store>();

// createSelector with types defined ready to be used
export const createAppSelector = createSelector.withTypes<RootState>();
